interface Props {
  className?: string;
}

export const CloseIcon = ({className}: Props): JSX.Element => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 0C74.5104 0 96 21.492 96 48C96 74.5104 74.5104 96 48 96C21.4896 96 0 74.5104 0 48C0 21.492 21.4896 0 48 0Z"
        fill="#F5F5F6"
      />
      <path
        d="M47.6158 49.5519C48.4111 49.5519 49.0995 49.262 49.6802 48.6804C50.2611 48.0997 50.5522 47.4112 50.5522 46.6162V31.9361C50.5522 31.1408 50.2614 30.4528 49.6802 29.872C49.0996 29.2906 48.4111 29 47.6158 29C46.8205 29 46.1325 29.2909 45.5514 29.872C44.9703 30.4528 44.6797 31.1411 44.6797 31.9361V46.6163C44.6797 47.4112 44.9703 48.0997 45.5514 48.6805C46.1325 49.262 46.8207 49.5519 47.6158 49.5519Z"
        fill="#79818C"
      />
      <path
        d="M63.3857 41.6845C62.1545 39.2228 60.4229 37.1583 58.1905 35.4917C57.5482 35.0024 56.8219 34.8112 56.0114 34.9181C55.2009 35.0252 54.5587 35.4075 54.0847 36.0648C53.5953 36.707 53.4084 37.4294 53.5228 38.2323C53.6371 39.0355 54.016 39.6813 54.6582 40.1707C56.1561 41.3022 57.3152 42.6863 58.1329 44.3224C58.951 45.9585 59.3596 47.7019 59.3596 49.5518C59.3596 51.1426 59.05 52.6599 58.4308 54.1052C57.8118 55.5503 56.9743 56.8001 55.9191 57.8553C54.8638 58.9103 53.6143 59.7474 52.169 60.3668C50.7239 60.9862 49.2063 61.2963 47.616 61.2963C46.0259 61.2963 44.5081 60.9862 43.0631 60.3668C41.6179 59.7474 40.368 58.9103 39.3127 57.8553C38.2579 56.8001 37.4206 55.5503 36.8012 54.1052C36.182 52.6599 35.8723 51.1426 35.8723 49.5518C35.8723 47.7019 36.2814 45.9587 37.0994 44.3224C37.9175 42.6864 39.0758 41.3024 40.5743 40.1707C41.2165 39.681 41.5948 39.0353 41.7097 38.2323C41.8243 37.4298 41.6371 36.707 41.1477 36.0648C40.6736 35.4075 40.0355 35.0251 39.2325 34.9181C38.4296 34.8111 37.6993 35.0024 37.0419 35.4917C34.8091 37.1583 33.0776 39.2228 31.8464 41.6845C30.6153 44.1466 30 46.769 30 49.5518C30 51.9377 30.4664 54.2158 31.3991 56.3872C32.3321 58.5586 33.5858 60.4315 35.161 62.0068C36.7358 63.5816 38.6091 64.8359 40.7807 65.7678C42.9521 66.701 45.2305 67.1678 47.6159 67.1678C50.0014 67.1678 52.2797 66.701 54.4512 65.7678C56.6228 64.8356 58.496 63.5816 60.071 62.0068C61.6458 60.432 62.8995 58.5586 63.8323 56.3872C64.7651 54.2158 65.2312 51.9371 65.2312 49.5518C65.2313 46.7689 64.6168 44.1465 63.3857 41.6845Z"
        fill="#79818C"
      />
    </svg>
  );
};
